import { TextField, type SxProps, type Theme } from '@mui/material'
import type React from 'react'
import { defaultSx } from './SurveyTextField.styles'

interface SurveyTextFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  rows?: number
  height?: string | number
  dataTestId?: string
  sx?: SxProps<Theme>
}

export const SurveyTextField: React.FC<SurveyTextFieldProps> = ({
  value,
  onChange,
  placeholder,
  dataTestId,
  height,
  sx
}) => {
  return (
    <TextField
      multiline
      variant="filled"
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? 'Add details here'}
      rows={3}
      data-testid={dataTestId}
      sx={{
        ...defaultSx,
        ...(height != null && { height }),
        ...sx
      }}
    />
  )
}
